const createRegexEscaper = () => {
  const regex = new RegExp("[.*+?^${}()|[\\]\\\\]");
  return (template) => template.replace(regex, "\\$&");
};
const createStaticReplacerBuilder = (keys, escapeRegex) => {
  if (!(keys == null ? void 0 : keys.length)) {
    return () => (template) => template;
  }
  if (!escapeRegex) {
    escapeRegex = createRegexEscaper();
  }
  const regex = new RegExp(keys.map((x) => `(?:${escapeRegex(x)})`).join("|"), "g");
  return (slots) => {
    return (template) => template.replace(regex, (placeholder) => slots[placeholder] ?? placeholder);
  };
};
const createStaticReplacer = (value, escapeRegex) => {
  if (!value) {
    return (template) => template;
  }
  const keys = Object.keys(value);
  const replacer = createStaticReplacerBuilder(keys, escapeRegex);
  return replacer(value);
};
export {
  createRegexEscaper,
  createStaticReplacer,
  createStaticReplacerBuilder
};
//# sourceMappingURL=regexTools.mjs.map
